export const MAX_DISPLAY_IN_STOCK_QUANTITY = 9999;
